/* 🤖 this file was generated by svg-to-ts */
export const matIconMediaBluetoothOn: {
  name: 'media-bluetooth-on';
  data: string;
} = {
  name: 'media-bluetooth-on',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m9 3 .01 10.55c-.6-.34-1.28-.55-2-.55a4.001 4.001 0 1 0 0 8C9.23 21 11 19.21 11 17V7h4V3H9zm12 9.43L17.57 9h-.6v4.55l-2.75-2.75-.85.85L16.73 15l-3.35 3.35.85.85 2.75-2.75V21h.6L21 17.57 18.42 15 21 12.43zm-2.83-1.13 1.13 1.13-1.13 1.13V11.3zm1.13 6.27-1.13 1.13v-2.26l1.13 1.13z"/></svg>`
};
